import productApi from "@api/products" //eslint-disable-line
import Vue from 'vue'

export default {
    namespaced: true,
    state: {
        loading: {
            reviews: false,
            review: false,
            reviewSave: false,
        },
        errors: {
            reviews: null,
            review: null,
            reviewSave: null,
        },
        reviews: [],
        review: {},
    },
    getters: {
        reviews: state => state.reviews,
        review: state => state.review,
        reviewsReviewLoadingState: state => name => state.loading[name],
        reviewsReviewErrorState: state => name => state.errors[name],
    },
    mutations: {
        setError(state, error) {
            Vue.set(state.errors, error.name, error.value)
        },
        setLoadingState(state, loading) {
            Vue.set(state.loading, loading.name, loading.value)
        },
        reviews(state, reviews) {
            Vue.set(state, 'reviews', reviews)
        },
        review(state, review) {
            Vue.set(state, 'review', review)
        },
        updateReviewProperty(state, payload) {
            Vue.set(state.review, payload.property, payload.value)
        },
    },
    actions: {
        loadReviews({ commit }, params = {}) {
            commit('setLoadingState', { name: 'reviews', value: true })
            return productApi.getUserReviews(params)
                .then(response => {
                    commit('reviews', response.data)
                    return response.data;
                })
                .catch(() => {
                    commit('setError', { name: 'reviews', value: true })
                })
                .finally(() => {
                    commit('setLoadingState', { name: 'reviews', value: false })
                })
        },
        loadReview({ commit }, uuid) {
            commit('setLoadingState', { name: 'review', value: true })

            productApi.getUserReview(uuid)
                .then(response => {
                    const { data } = response.data
                    commit('review', data)
                })
                .catch(() => {
                    commit('setError', { name: 'review', value: true })
                })
                .finally(() => {
                    commit('setLoadingState', { name: 'review', value: false })
                })
        },
        updateReview({ commit, state }) {
            commit('setLoadingState', { name: 'reviewSave', value: true })
            commit('setError', { name: 'reviewSave', value: false })

            return productApi.updateUserReview(state.review.uuid, state.review)
                .catch(() => {
                    commit('setError', {
                        name: 'reviewSave',
                        value: true,
                    })
                })
                .finally(() => {
                    commit('setLoadingState', { name: 'reviewSave', value: false })
                })
        },
        updateReviewProperty({ commit }, payload) {
            commit('updateReviewProperty', payload)
        },
    },
}
